import { Props as ButtonWebProps } from '@rover/kibble/core/Button/Button';
import { ButtonSizes } from '@rover/kibble/core/Button/Button.common';
import { Props as ButtonNativeProps } from '@rover/kibble/core/Button/Button.native';

export type ButtonWithCountBadgeCommonProps = {
  badgeCount?: number;
  ariaLabel?: string;
  badgeTestID?: string;
};

export const BUTTON_SIZE_TO_BADGE_SIZE_MAP: Record<ButtonSizes, number> = {
  small: 17,
  default: 24,
  large: 28,
};

export type ButtonWithCountBadgeNativeProps = ButtonWithCountBadgeCommonProps & ButtonNativeProps;

export type ButtonWithCountBadgeWebProps = ButtonWithCountBadgeCommonProps & ButtonWebProps;
